import { HttpClient } from "@angular/common/http";
import { VersionService } from "@app/core/services/version.service";
import { TranslateLoader } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";

export class CustomTranslateHttpLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly prefix: string,
    private readonly suffix: string,
    private readonly isProduction: boolean,
    private readonly versionService: VersionService,
  ) {}

  /**
   * Function to generate a cache-busting string for translation file URLs.
   *
   * In development, returns the current timestamp in ms to ensure fresh translations on every load.
   * In production, returns the osiris version to cache translations per release.
   * For that it has to use the VersionService, ensure that the osirisVersion is set and use it for getting the translation file.
   * @returns Cache-busting query parameter value
   */
  private getCacheBusterString(): Observable<string> {
    if (this.isProduction) {
      if (this.versionService.osirisVersion && this.versionService.osirisVersion !== "?") {
        return of(this.versionService.osirisVersion);
      }
      return this.versionService.setOsirisVersion();
    }
    return of(Date.now().toString());
  }

  getTranslation(lang: string): Observable<{ [key: string]: string }> {
    return this.getCacheBusterString().pipe(
      switchMap((cacheBusterString) => {
        const cacheBusterSuffix = cacheBusterString ? `?v=${cacheBusterString}` : "";
        return this.http.get<{ [key: string]: string }>(`${this.prefix}${lang}${this.suffix}${cacheBusterSuffix}`);
      }),
    );
  }
}
